import { defineStore } from 'pinia';
import { ref } from 'vue';

export const UNDO_TOAST_MS = 6000;

export const useUndoToastStore = defineStore('undoToast', () => {
  const message = ref<string | null>(null);
  let onUndo: (() => Promise<void>) | null = null;
  let timer: ReturnType<typeof setTimeout> | null = null;

  function clearTimer(): void {
    if (timer !== null) clearTimeout(timer);
    timer = null;
  }

  function dismiss(): void {
    clearTimer();
    message.value = null;
    onUndo = null;
  }

  function show(text: string, callback: () => Promise<void>): void {
    clearTimer();
    message.value = text;
    onUndo = callback;
    timer = setTimeout(dismiss, UNDO_TOAST_MS);
  }

  // Takes the callback out before awaiting so a double click can't run it twice; a failure
  // rejects to the caller, which owns surfacing it.
  async function undo(): Promise<void> {
    const callback = onUndo;
    dismiss();
    if (callback) await callback();
  }

  return { message, show, undo, dismiss };
});
